import React, { useEffect, useState } from 'react';
import { EventProductDetailReportV2 } from '@/model/EventProductDetailReportV2';
import { States } from '@/helpers/common/states';
import api, { AxiosError } from '@/services/api';
import { toast } from 'react-toastify';
import { SaleProductProductsContent } from './ui';
import { ReportControllerProps } from '../../types';

interface StateProps {
  reportController: ReportControllerProps;
  setState: (state: States) => void;
}

export const SaleProductProducts: React.FC<StateProps> = ({ reportController, setState }) => {
  const { eventId, singleEvent } = reportController;
  const [products, setProducts] = useState<EventProductDetailReportV2[]>([]);

  const handleGetSaleProducts = async (): Promise<void> => {
    try {
      setState(States.loading);
      const { data } = await api.get<EventProductDetailReportV2[]>(
        `event/report/${eventId}/sale-product/product?singleEvent=${singleEvent}`,
      );
      if (data) {
        setProducts(data);
      }
    } catch (error) {
      const err = error as AxiosError;
      toast.error(err.message);
    } finally {
      setState(States.default);
    }
  };

  useEffect(() => {
    handleGetSaleProducts();
  }, []);
  return <SaleProductProductsContent products={products} />;
};
